import React from "react";
import { Link } from "react-router-dom";

function Navigation({ lang = false }) {
  return (
    <>
      {lang ? (
        <ul>
          <li>
            <a href="#">
              أنا <i className="fal fa-angle-down" />
            </a>
            <ul className="sub-menu">
              <li>
                <Link to="/">الصفحة الرئيسية 1</Link>
              </li>
              <li>
                <Link to="/home-two">الصفحة الرئيسية 2</Link>
              </li>
              <li>
                <Link to="/home-three">المنزل 3</Link>
              </li>
              <li>
                <Link to="/home-four">المنزل 4</Link>
              </li>
              <li>
                <Link to="/home-five">المنزل 5</Link>
              </li>
              <li>
                <Link to="/home-six">الصفحة الرئيسية 6</Link>
              </li>
              <li>
                <Link to="/home-seven">المنزل 7</Link>
              </li>
              <li>
                <Link to="/home-eight">الصفحة الرئيسية 8</Link>
              </li>
              <li>
                <Link to="/home-dark">الصفحة الرئيسية الظلام</Link>
              </li>
              <li>
                <Link to="/home-rtl">الصفحة الرئيسية Rtl</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/service">خدمة</Link>
          </li>
          <li>
            <a href="#">
              الصفحات <i className="fal fa-angle-down" />
            </a>
            <ul className="sub-menu">
              <li>
                <Link to="/about-us">عن</Link>
              </li>
              <li>
                <Link to="/error">خطأ</Link>
              </li>
            </ul>
          </li>
          <li>
            <a href="#">
              أخبار <i className="fal fa-angle-down" />
            </a>
            <ul className="sub-menu">
              <li>
                <Link to="/news">صفحة الأخبار </Link>
              </li>
              <li>
                <Link to="/news/single-news">أخبار واحدة</Link>
              </li>
            </ul>
          </li>
          <li>
            <Link to="/contact">اتصل</Link>
          </li>
        </ul>
      ) : (
        <ul>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/rules">Rules</Link>
          </li>
          <li>
            <Link to="#">
              Sports <i className="fal fa-angle-down" />
            </Link>
            <ul className="sub-menu">
              <li>
                <Link to="/sports/football">Football</Link>
              </li>
              <li>
                <Link to="/sports/turf-cricket-boys">Turf Cricket (Boys)</Link>
              </li>
              <li>
                <Link to="/sports/turf-cricket-girls">
                  Turf Cricket (Girls)
                </Link>
              </li>
              <li>
                <Link to="/sports/volleyball">Volleyball</Link>
              </li>
              <li>
                <Link to="/sports/basketball">Basketball</Link>
              </li>
              <li>
                <Link to="/sports/snooker">Snooker</Link>
              </li>
              <li>
                <Link to="/sports/squash">Squash</Link>
              </li>
              <li>
                <Link to="/sports/lawn-tennis">Lawn Tennis</Link>
              </li>
              <li>
                <Link to="/sports/table-tennis">Table Tennis</Link>
              </li>
              <li>
                <Link to="/sports/badminton">Badminton</Link>
              </li>
              <li>
                <Link to="/sports/chess">Chess</Link>
              </li>
              <li>
                <Link to="/sports/carrom">Carrom</Link>
              </li>
              <li>
                <Link to="/sports/swimming">Swimming</Link>
              </li>
              <li>
                <Link to="/sports/sprint">Sprint</Link>
              </li>
              {/* <li>
                <Link to="/sports/throw-ball">Throw Ball</Link>
              </li> */}
            </ul>
          </li>
          {/* <li>
            <Link to="/contact">Contact</Link>
          </li> */}
        </ul>
      )}
    </>
  );
}

export default Navigation;
